<div class="main-div">
  <div class="logo-div">
    <img
      loading="lazy"
      style="width: 450px"
      src="../../../../assets/SI.logo.horizontal_black.svg"
      alt="logo_vertical"
    />
    <div class="partner-label">
      <span #idpLabel>PLEASE SELECT YOUR ID PROVIDER</span>
    </div>
  </div>
  <div class="card-div">
    @for (partner of partnersList; track partner; let i = $index) {
      <div class="partner-card" (click)="singleSignOn(partner.toLowerCase())">
        <img
          loading="lazy"
          class="partner-img"
          src="../../../../assets/logos/{{ partner.toLowerCase() }}.png"
          [alt]="partner.toLowerCase()"
        />
      </div>
    }
  </div>
</div>
